import { AgentRef, AgentView } from 'pbts/c1/api/user/v1/user'
import { AgentSearchServiceClient, AgentServiceClient } from 'pbts/c1/api/user/v1/user.client'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const createAgentApi = createMutationApi(
    AgentServiceClient,
    'createAgent',
    (r): AgentView => r?.agentView as AgentView,
    AgentRef.typeName,
)

export const getAgentApi = createUnaryApi(
    AgentServiceClient,
    'getAgent',
    (r): AgentView => r?.agentView as AgentView,
    AgentRef.typeName,
)

export const deleteAgentApi = createMutationApi(
    AgentServiceClient,
    'deleteAgent',
    undefined,
    AgentRef.typeName,
)

export const listAgentsApi = createPagedListApi(
    AgentServiceClient,
    'listAgents',
    undefined,
    AgentRef.typeName,
)

export const setAgentInstructionsApi = createMutationApi(
    AgentServiceClient,
    'setAgentInstructions',
    (r): AgentView => r?.agentView as AgentView,
    AgentRef.typeName,
)

export const searchAgentsApi = createPagedListApi(
    AgentSearchServiceClient,
    'search',
    (r): AgentView[] => r?.list.map((a) => a) as AgentView[],
    AgentRef.typeName,
)
